import { render, staticRenderFns } from "./ShipReviewTrendAnalysisItem.vue?vue&type=template&id=ccd65756&"
import script from "./ShipReviewTrendAnalysisItem.vue?vue&type=script&lang=js&"
export * from "./ShipReviewTrendAnalysisItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports